import React from "react";
import Pagenator from "../common/Paginator/Pagenator.tsx";
import User from "./User.jsx";
import { userType } from "../../Type/Type.js";

type PropsType = {
    totalUsersCount: number
    pageSize: number
    onPageChanged: (pageNumber: number) => void
    currentPage: number
    users: Array<userType>
    followingIsProgres: Array<number>
    unfollow: (userId: number) => void
    follow: (userId: number) => void

}

let Users: React.FC<PropsType> = ({totalUsersCount,pageSize,onPageChanged,currentPage,users, ...props}) => {
    return <div>
       <Pagenator currentPage={currentPage} onPageChanged={onPageChanged}
        totalUsersCount={totalUsersCount} pageSize={pageSize}/>
            {
                users.map(u => <User user={u} key={u.id}
                 followingIsProgres={props.followingIsProgres}
                 unfollow={props.unfollow} follow={props.follow}/>
            )}
        
            </div>
}

export default Users;